/*global jQuery crm:false*/
var unternehmen = (function($) {

    var did = parseInt($('#dok_id').val(), 10);

    return {
        createDokument: function(fid) {
            $('#write_doc').click(function(e) {
                e.preventDefault();
                $.ajax({
                    type: "GET",
                    url: crm.ajaxRequestUri + 'company/' + fid,
                    data: "ajax_action=receive&ajax_format=json&ajax_requestname=" +
                            'createDokument' + '&tab=unternehmen&fid=' + fid +
                            "&fdok_id=" + did,
                    success: function(data) {
                        location.href = data;
                    }
                });
            });
        }
    };
}(jQuery));